import { jsx } from 'react/jsx-runtime';

// we need to use an iframe to be the intermediary in communications between the oauth popup and the sdk
// because of twitter limitations with accessing the window.opener and BroadcastChannel not working between
// different origins (our api redirect page and the app where the sdk is running)
// https://linear.app/dynamic-labs/issue/GVTY-17/[frontend]-fix-twitter-linking
const OAuthIFrameContainer = () => (jsx("div", { id: 'oauth-iframe-container', "data-testid": 'oauth-iframe-container', style: { height: 0, visibility: 'hidden', width: 0 } }));

export { OAuthIFrameContainer };
